import { useAppProperties } from "@/hooks";
import { useTranslate } from "@/providers/context";

export const TermsLinks = () => {
  const { translate } = useTranslate();
  const { data } = useAppProperties();

  return (
    <div className="subtitle text-item-secondary">
      {translate("By subscribing, you agree to our")}{" "}
      <span
        onClick={() => window.open(data?.TermsOfService ?? "")}
        className="cursor-pointer underline"
      >
        {translate("Terms of Service")}
      </span>{" "}
      {translate("and")}{" "}
      <span
        onClick={() => window.open(data?.PrivacyPolicy ?? "")}
        className="cursor-pointer underline"
      >
        {translate("Privacy Policy")}
      </span>
      .
    </div>
  );
};
